/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Area Restrita API
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreateNpsCampaignCommand,
  CreateNpsCampaignCommandResponse,
  CurrentNpsCampaignQueryResponse,
  GetNpsCampaignResultsBuslinesParams,
  GetNpsCampaignResultsCommentsParams,
  GetNpsCampaignResultsSchedulesParams,
  GetNpsCampaignsParams,
  NpsCampaignDetailQueryResponse,
  NpsCampaignResultsBuslinesQueryResponse,
  NpsCampaignResultsCommentsQueryResponse,
  NpsCampaignResultsSchedulesQueryResponse,
  NpsCampaignResultsSummaryQueryResponse,
  NpsCampaignsQueryResponse,
  SubmitNpsResponseBody,
  UpdateNpsCampaignBody
} from '../../model';

import { instance } from '../../index';
import type { ErrorType, BodyType } from '../../index';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getNpsCampaigns = (
    params: GetNpsCampaignsParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<NpsCampaignsQueryResponse>(
      {url: `/api/v1/nps/campaigns`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetNpsCampaignsQueryKey = (params: GetNpsCampaignsParams,) => {
    return [`/api/v1/nps/campaigns`, ...(params ? [params]: [])] as const;
    }

    
export const getGetNpsCampaignsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaigns>>, GetNpsCampaignsParams['page']>, TError = ErrorType<unknown>>(params: GetNpsCampaignsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaigns>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaigns>>, QueryKey, GetNpsCampaignsParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsCampaignsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsCampaigns>>, QueryKey, GetNpsCampaignsParams['page']> = ({ signal, pageParam }) => getNpsCampaigns({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaigns>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaigns>>, QueryKey, GetNpsCampaignsParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNpsCampaignsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsCampaigns>>>
export type GetNpsCampaignsInfiniteQueryError = ErrorType<unknown>


export function useGetNpsCampaignsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaigns>>, GetNpsCampaignsParams['page']>, TError = ErrorType<unknown>>(
 params: GetNpsCampaignsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaigns>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaigns>>, QueryKey, GetNpsCampaignsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaigns>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaigns>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaigns>>, GetNpsCampaignsParams['page']>, TError = ErrorType<unknown>>(
 params: GetNpsCampaignsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaigns>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaigns>>, QueryKey, GetNpsCampaignsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaigns>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaigns>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaigns>>, GetNpsCampaignsParams['page']>, TError = ErrorType<unknown>>(
 params: GetNpsCampaignsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaigns>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaigns>>, QueryKey, GetNpsCampaignsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNpsCampaignsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaigns>>, GetNpsCampaignsParams['page']>, TError = ErrorType<unknown>>(
 params: GetNpsCampaignsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaigns>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaigns>>, QueryKey, GetNpsCampaignsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNpsCampaignsInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetNpsCampaignsQueryOptions = <TData = Awaited<ReturnType<typeof getNpsCampaigns>>, TError = ErrorType<unknown>>(params: GetNpsCampaignsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaigns>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsCampaignsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsCampaigns>>> = ({ signal }) => getNpsCampaigns(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaigns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNpsCampaignsQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsCampaigns>>>
export type GetNpsCampaignsQueryError = ErrorType<unknown>


export function useGetNpsCampaigns<TData = Awaited<ReturnType<typeof getNpsCampaigns>>, TError = ErrorType<unknown>>(
 params: GetNpsCampaignsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaigns>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaigns>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaigns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaigns<TData = Awaited<ReturnType<typeof getNpsCampaigns>>, TError = ErrorType<unknown>>(
 params: GetNpsCampaignsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaigns>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaigns>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaigns>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaigns<TData = Awaited<ReturnType<typeof getNpsCampaigns>>, TError = ErrorType<unknown>>(
 params: GetNpsCampaignsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaigns>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNpsCampaigns<TData = Awaited<ReturnType<typeof getNpsCampaigns>>, TError = ErrorType<unknown>>(
 params: GetNpsCampaignsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaigns>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNpsCampaignsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetNpsCampaignsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getNpsCampaigns>>, TError = ErrorType<unknown>>(params: GetNpsCampaignsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaigns>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsCampaignsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsCampaigns>>> = ({ signal }) => getNpsCampaigns(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaigns>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNpsCampaignsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsCampaigns>>>
export type GetNpsCampaignsSuspenseQueryError = ErrorType<unknown>


export function useGetNpsCampaignsSuspense<TData = Awaited<ReturnType<typeof getNpsCampaigns>>, TError = ErrorType<unknown>>(
 params: GetNpsCampaignsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaigns>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignsSuspense<TData = Awaited<ReturnType<typeof getNpsCampaigns>>, TError = ErrorType<unknown>>(
 params: GetNpsCampaignsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaigns>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignsSuspense<TData = Awaited<ReturnType<typeof getNpsCampaigns>>, TError = ErrorType<unknown>>(
 params: GetNpsCampaignsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaigns>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNpsCampaignsSuspense<TData = Awaited<ReturnType<typeof getNpsCampaigns>>, TError = ErrorType<unknown>>(
 params: GetNpsCampaignsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaigns>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNpsCampaignsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const createNpsCampaign = (
    createNpsCampaignCommand: BodyType<CreateNpsCampaignCommand>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CreateNpsCampaignCommandResponse>(
      {url: `/api/v1/nps/campaigns`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createNpsCampaignCommand, signal
    },
      options);
    }
  


export const getCreateNpsCampaignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNpsCampaign>>, TError,{data: BodyType<CreateNpsCampaignCommand>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof createNpsCampaign>>, TError,{data: BodyType<CreateNpsCampaignCommand>}, TContext> => {
    
const mutationKey = ['createNpsCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createNpsCampaign>>, {data: BodyType<CreateNpsCampaignCommand>}> = (props) => {
          const {data} = props ?? {};

          return  createNpsCampaign(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateNpsCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof createNpsCampaign>>>
    export type CreateNpsCampaignMutationBody = BodyType<CreateNpsCampaignCommand>
    export type CreateNpsCampaignMutationError = ErrorType<unknown>

    export const useCreateNpsCampaign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createNpsCampaign>>, TError,{data: BodyType<CreateNpsCampaignCommand>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof createNpsCampaign>>,
        TError,
        {data: BodyType<CreateNpsCampaignCommand>},
        TContext
      > => {

      const mutationOptions = getCreateNpsCampaignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getNpsCampaign = (
    id: string,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<NpsCampaignDetailQueryResponse>(
      {url: `/api/v1/nps/campaigns/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetNpsCampaignQueryKey = (id: string,) => {
    return [`/api/v1/nps/campaigns/${id}`] as const;
    }

    
export const getGetNpsCampaignInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaign>>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsCampaignQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsCampaign>>> = ({ signal }) => getNpsCampaign(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNpsCampaignInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsCampaign>>>
export type GetNpsCampaignInfiniteQueryError = ErrorType<unknown>


export function useGetNpsCampaignInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaign>>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaign>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaign>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaign>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaign>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNpsCampaignInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaign>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNpsCampaignInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetNpsCampaignQueryOptions = <TData = Awaited<ReturnType<typeof getNpsCampaign>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsCampaignQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsCampaign>>> = ({ signal }) => getNpsCampaign(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNpsCampaignQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsCampaign>>>
export type GetNpsCampaignQueryError = ErrorType<unknown>


export function useGetNpsCampaign<TData = Awaited<ReturnType<typeof getNpsCampaign>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaign>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaign<TData = Awaited<ReturnType<typeof getNpsCampaign>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaign>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaign<TData = Awaited<ReturnType<typeof getNpsCampaign>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNpsCampaign<TData = Awaited<ReturnType<typeof getNpsCampaign>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNpsCampaignQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetNpsCampaignSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getNpsCampaign>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsCampaignQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsCampaign>>> = ({ signal }) => getNpsCampaign(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNpsCampaignSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsCampaign>>>
export type GetNpsCampaignSuspenseQueryError = ErrorType<unknown>


export function useGetNpsCampaignSuspense<TData = Awaited<ReturnType<typeof getNpsCampaign>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignSuspense<TData = Awaited<ReturnType<typeof getNpsCampaign>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignSuspense<TData = Awaited<ReturnType<typeof getNpsCampaign>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNpsCampaignSuspense<TData = Awaited<ReturnType<typeof getNpsCampaign>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNpsCampaignSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateNpsCampaign = (
    id: string,
    updateNpsCampaignBody: BodyType<UpdateNpsCampaignBody>,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/nps/campaigns/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateNpsCampaignBody
    },
      options);
    }
  


export const getUpdateNpsCampaignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNpsCampaign>>, TError,{id: string;data: BodyType<UpdateNpsCampaignBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateNpsCampaign>>, TError,{id: string;data: BodyType<UpdateNpsCampaignBody>}, TContext> => {
    
const mutationKey = ['updateNpsCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNpsCampaign>>, {id: string;data: BodyType<UpdateNpsCampaignBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  updateNpsCampaign(id,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateNpsCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof updateNpsCampaign>>>
    export type UpdateNpsCampaignMutationBody = BodyType<UpdateNpsCampaignBody>
    export type UpdateNpsCampaignMutationError = ErrorType<unknown>

    export const useUpdateNpsCampaign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNpsCampaign>>, TError,{id: string;data: BodyType<UpdateNpsCampaignBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof updateNpsCampaign>>,
        TError,
        {id: string;data: BodyType<UpdateNpsCampaignBody>},
        TContext
      > => {

      const mutationOptions = getUpdateNpsCampaignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const deleteNpsCampaign = (
    id: string,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/nps/campaigns/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteNpsCampaignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNpsCampaign>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteNpsCampaign>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['deleteNpsCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteNpsCampaign>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteNpsCampaign(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteNpsCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof deleteNpsCampaign>>>
    
    export type DeleteNpsCampaignMutationError = ErrorType<unknown>

    export const useDeleteNpsCampaign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteNpsCampaign>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof deleteNpsCampaign>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteNpsCampaignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const exportNpsCampaignResults = (
    id: string,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<Blob>(
      {url: `/api/v1/nps/campaigns/${id}/export`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }
  

export const getExportNpsCampaignResultsQueryKey = (id: string,) => {
    return [`/api/v1/nps/campaigns/${id}/export`] as const;
    }

    
export const getExportNpsCampaignResultsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof exportNpsCampaignResults>>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportNpsCampaignResultsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportNpsCampaignResults>>> = ({ signal }) => exportNpsCampaignResults(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ExportNpsCampaignResultsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof exportNpsCampaignResults>>>
export type ExportNpsCampaignResultsInfiniteQueryError = ErrorType<unknown>


export function useExportNpsCampaignResultsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof exportNpsCampaignResults>>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportNpsCampaignResults>>,
          TError,
          Awaited<ReturnType<typeof exportNpsCampaignResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useExportNpsCampaignResultsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof exportNpsCampaignResults>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportNpsCampaignResults>>,
          TError,
          Awaited<ReturnType<typeof exportNpsCampaignResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useExportNpsCampaignResultsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof exportNpsCampaignResults>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useExportNpsCampaignResultsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof exportNpsCampaignResults>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getExportNpsCampaignResultsInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getExportNpsCampaignResultsQueryOptions = <TData = Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportNpsCampaignResultsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportNpsCampaignResults>>> = ({ signal }) => exportNpsCampaignResults(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ExportNpsCampaignResultsQueryResult = NonNullable<Awaited<ReturnType<typeof exportNpsCampaignResults>>>
export type ExportNpsCampaignResultsQueryError = ErrorType<unknown>


export function useExportNpsCampaignResults<TData = Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportNpsCampaignResults>>,
          TError,
          Awaited<ReturnType<typeof exportNpsCampaignResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useExportNpsCampaignResults<TData = Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportNpsCampaignResults>>,
          TError,
          Awaited<ReturnType<typeof exportNpsCampaignResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useExportNpsCampaignResults<TData = Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useExportNpsCampaignResults<TData = Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getExportNpsCampaignResultsQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getExportNpsCampaignResultsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportNpsCampaignResultsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportNpsCampaignResults>>> = ({ signal }) => exportNpsCampaignResults(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ExportNpsCampaignResultsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof exportNpsCampaignResults>>>
export type ExportNpsCampaignResultsSuspenseQueryError = ErrorType<unknown>


export function useExportNpsCampaignResultsSuspense<TData = Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useExportNpsCampaignResultsSuspense<TData = Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useExportNpsCampaignResultsSuspense<TData = Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useExportNpsCampaignResultsSuspense<TData = Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof exportNpsCampaignResults>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getExportNpsCampaignResultsSuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNpsCampaignResultsSummary = (
    id: string,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<NpsCampaignResultsSummaryQueryResponse>(
      {url: `/api/v1/nps/campaigns/${id}/results/summary`, method: 'GET', signal
    },
      options);
    }
  

export const getGetNpsCampaignResultsSummaryQueryKey = (id: string,) => {
    return [`/api/v1/nps/campaigns/${id}/results/summary`] as const;
    }

    
export const getGetNpsCampaignResultsSummaryInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsCampaignResultsSummaryQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>> = ({ signal }) => getNpsCampaignResultsSummary(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNpsCampaignResultsSummaryInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>>
export type GetNpsCampaignResultsSummaryInfiniteQueryError = ErrorType<unknown>


export function useGetNpsCampaignResultsSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNpsCampaignResultsSummaryInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNpsCampaignResultsSummaryInfiniteQueryOptions(id,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetNpsCampaignResultsSummaryQueryOptions = <TData = Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsCampaignResultsSummaryQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>> = ({ signal }) => getNpsCampaignResultsSummary(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNpsCampaignResultsSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>>
export type GetNpsCampaignResultsSummaryQueryError = ErrorType<unknown>


export function useGetNpsCampaignResultsSummary<TData = Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsSummary<TData = Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsSummary<TData = Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNpsCampaignResultsSummary<TData = Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNpsCampaignResultsSummaryQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetNpsCampaignResultsSummarySuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError = ErrorType<unknown>>(id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsCampaignResultsSummaryQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>> = ({ signal }) => getNpsCampaignResultsSummary(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNpsCampaignResultsSummarySuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>>
export type GetNpsCampaignResultsSummarySuspenseQueryError = ErrorType<unknown>


export function useGetNpsCampaignResultsSummarySuspense<TData = Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError = ErrorType<unknown>>(
 id: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsSummarySuspense<TData = Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsSummarySuspense<TData = Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNpsCampaignResultsSummarySuspense<TData = Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSummary>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNpsCampaignResultsSummarySuspenseQueryOptions(id,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNpsCampaignResultsBuslines = (
    id: string,
    params: GetNpsCampaignResultsBuslinesParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<NpsCampaignResultsBuslinesQueryResponse>(
      {url: `/api/v1/nps/campaigns/${id}/results/buslines`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetNpsCampaignResultsBuslinesQueryKey = (id: string,
    params: GetNpsCampaignResultsBuslinesParams,) => {
    return [`/api/v1/nps/campaigns/${id}/results/buslines`, ...(params ? [params]: [])] as const;
    }

    
export const getGetNpsCampaignResultsBuslinesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, GetNpsCampaignResultsBuslinesParams['page']>, TError = ErrorType<unknown>>(id: string,
    params: GetNpsCampaignResultsBuslinesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, QueryKey, GetNpsCampaignResultsBuslinesParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsCampaignResultsBuslinesQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, QueryKey, GetNpsCampaignResultsBuslinesParams['page']> = ({ signal, pageParam }) => getNpsCampaignResultsBuslines(id,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, QueryKey, GetNpsCampaignResultsBuslinesParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNpsCampaignResultsBuslinesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>>
export type GetNpsCampaignResultsBuslinesInfiniteQueryError = ErrorType<unknown>


export function useGetNpsCampaignResultsBuslinesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, GetNpsCampaignResultsBuslinesParams['page']>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsBuslinesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, QueryKey, GetNpsCampaignResultsBuslinesParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsBuslinesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, GetNpsCampaignResultsBuslinesParams['page']>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsBuslinesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, QueryKey, GetNpsCampaignResultsBuslinesParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsBuslinesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, GetNpsCampaignResultsBuslinesParams['page']>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsBuslinesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, QueryKey, GetNpsCampaignResultsBuslinesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNpsCampaignResultsBuslinesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, GetNpsCampaignResultsBuslinesParams['page']>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsBuslinesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, QueryKey, GetNpsCampaignResultsBuslinesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNpsCampaignResultsBuslinesInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetNpsCampaignResultsBuslinesQueryOptions = <TData = Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError = ErrorType<unknown>>(id: string,
    params: GetNpsCampaignResultsBuslinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsCampaignResultsBuslinesQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>> = ({ signal }) => getNpsCampaignResultsBuslines(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNpsCampaignResultsBuslinesQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>>
export type GetNpsCampaignResultsBuslinesQueryError = ErrorType<unknown>


export function useGetNpsCampaignResultsBuslines<TData = Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsBuslinesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsBuslines<TData = Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsBuslinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsBuslines<TData = Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsBuslinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNpsCampaignResultsBuslines<TData = Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsBuslinesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNpsCampaignResultsBuslinesQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetNpsCampaignResultsBuslinesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError = ErrorType<unknown>>(id: string,
    params: GetNpsCampaignResultsBuslinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsCampaignResultsBuslinesQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>> = ({ signal }) => getNpsCampaignResultsBuslines(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNpsCampaignResultsBuslinesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>>
export type GetNpsCampaignResultsBuslinesSuspenseQueryError = ErrorType<unknown>


export function useGetNpsCampaignResultsBuslinesSuspense<TData = Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsBuslinesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsBuslinesSuspense<TData = Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsBuslinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsBuslinesSuspense<TData = Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsBuslinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNpsCampaignResultsBuslinesSuspense<TData = Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsBuslinesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsBuslines>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNpsCampaignResultsBuslinesSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNpsCampaignResultsSchedules = (
    id: string,
    params: GetNpsCampaignResultsSchedulesParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<NpsCampaignResultsSchedulesQueryResponse>(
      {url: `/api/v1/nps/campaigns/${id}/results/schedules`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetNpsCampaignResultsSchedulesQueryKey = (id: string,
    params: GetNpsCampaignResultsSchedulesParams,) => {
    return [`/api/v1/nps/campaigns/${id}/results/schedules`, ...(params ? [params]: [])] as const;
    }

    
export const getGetNpsCampaignResultsSchedulesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, GetNpsCampaignResultsSchedulesParams['page']>, TError = ErrorType<unknown>>(id: string,
    params: GetNpsCampaignResultsSchedulesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, QueryKey, GetNpsCampaignResultsSchedulesParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsCampaignResultsSchedulesQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, QueryKey, GetNpsCampaignResultsSchedulesParams['page']> = ({ signal, pageParam }) => getNpsCampaignResultsSchedules(id,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, QueryKey, GetNpsCampaignResultsSchedulesParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNpsCampaignResultsSchedulesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>>
export type GetNpsCampaignResultsSchedulesInfiniteQueryError = ErrorType<unknown>


export function useGetNpsCampaignResultsSchedulesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, GetNpsCampaignResultsSchedulesParams['page']>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsSchedulesParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, QueryKey, GetNpsCampaignResultsSchedulesParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsSchedulesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, GetNpsCampaignResultsSchedulesParams['page']>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsSchedulesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, QueryKey, GetNpsCampaignResultsSchedulesParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsSchedulesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, GetNpsCampaignResultsSchedulesParams['page']>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsSchedulesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, QueryKey, GetNpsCampaignResultsSchedulesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNpsCampaignResultsSchedulesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, GetNpsCampaignResultsSchedulesParams['page']>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsSchedulesParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, QueryKey, GetNpsCampaignResultsSchedulesParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNpsCampaignResultsSchedulesInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetNpsCampaignResultsSchedulesQueryOptions = <TData = Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError = ErrorType<unknown>>(id: string,
    params: GetNpsCampaignResultsSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsCampaignResultsSchedulesQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>> = ({ signal }) => getNpsCampaignResultsSchedules(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNpsCampaignResultsSchedulesQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>>
export type GetNpsCampaignResultsSchedulesQueryError = ErrorType<unknown>


export function useGetNpsCampaignResultsSchedules<TData = Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsSchedulesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsSchedules<TData = Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsSchedules<TData = Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNpsCampaignResultsSchedules<TData = Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsSchedulesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNpsCampaignResultsSchedulesQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetNpsCampaignResultsSchedulesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError = ErrorType<unknown>>(id: string,
    params: GetNpsCampaignResultsSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsCampaignResultsSchedulesQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>> = ({ signal }) => getNpsCampaignResultsSchedules(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNpsCampaignResultsSchedulesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>>
export type GetNpsCampaignResultsSchedulesSuspenseQueryError = ErrorType<unknown>


export function useGetNpsCampaignResultsSchedulesSuspense<TData = Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsSchedulesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsSchedulesSuspense<TData = Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsSchedulesSuspense<TData = Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNpsCampaignResultsSchedulesSuspense<TData = Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsSchedulesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsSchedules>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNpsCampaignResultsSchedulesSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getNpsCampaignResultsComments = (
    id: string,
    params: GetNpsCampaignResultsCommentsParams,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<NpsCampaignResultsCommentsQueryResponse>(
      {url: `/api/v1/nps/campaigns/${id}/results/comments`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetNpsCampaignResultsCommentsQueryKey = (id: string,
    params: GetNpsCampaignResultsCommentsParams,) => {
    return [`/api/v1/nps/campaigns/${id}/results/comments`, ...(params ? [params]: [])] as const;
    }

    
export const getGetNpsCampaignResultsCommentsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, GetNpsCampaignResultsCommentsParams['page']>, TError = ErrorType<unknown>>(id: string,
    params: GetNpsCampaignResultsCommentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, QueryKey, GetNpsCampaignResultsCommentsParams['page']>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsCampaignResultsCommentsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, QueryKey, GetNpsCampaignResultsCommentsParams['page']> = ({ signal, pageParam }) => getNpsCampaignResultsComments(id,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, QueryKey, GetNpsCampaignResultsCommentsParams['page']> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNpsCampaignResultsCommentsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>>
export type GetNpsCampaignResultsCommentsInfiniteQueryError = ErrorType<unknown>


export function useGetNpsCampaignResultsCommentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, GetNpsCampaignResultsCommentsParams['page']>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsCommentsParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, QueryKey, GetNpsCampaignResultsCommentsParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaignResultsComments>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsCommentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, GetNpsCampaignResultsCommentsParams['page']>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsCommentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, QueryKey, GetNpsCampaignResultsCommentsParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaignResultsComments>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsCommentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, GetNpsCampaignResultsCommentsParams['page']>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsCommentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, QueryKey, GetNpsCampaignResultsCommentsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNpsCampaignResultsCommentsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, GetNpsCampaignResultsCommentsParams['page']>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsCommentsParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError, TData, Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, QueryKey, GetNpsCampaignResultsCommentsParams['page']>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNpsCampaignResultsCommentsInfiniteQueryOptions(id,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetNpsCampaignResultsCommentsQueryOptions = <TData = Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError = ErrorType<unknown>>(id: string,
    params: GetNpsCampaignResultsCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsCampaignResultsCommentsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>> = ({ signal }) => getNpsCampaignResultsComments(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNpsCampaignResultsCommentsQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>>
export type GetNpsCampaignResultsCommentsQueryError = ErrorType<unknown>


export function useGetNpsCampaignResultsComments<TData = Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsCommentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaignResultsComments>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaignResultsComments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsComments<TData = Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNpsCampaignResultsComments>>,
          TError,
          Awaited<ReturnType<typeof getNpsCampaignResultsComments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsComments<TData = Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNpsCampaignResultsComments<TData = Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsCommentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNpsCampaignResultsCommentsQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetNpsCampaignResultsCommentsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError = ErrorType<unknown>>(id: string,
    params: GetNpsCampaignResultsCommentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNpsCampaignResultsCommentsQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>> = ({ signal }) => getNpsCampaignResultsComments(id,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNpsCampaignResultsCommentsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>>
export type GetNpsCampaignResultsCommentsSuspenseQueryError = ErrorType<unknown>


export function useGetNpsCampaignResultsCommentsSuspense<TData = Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsCommentsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsCommentsSuspense<TData = Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsCommentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNpsCampaignResultsCommentsSuspense<TData = Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsCommentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetNpsCampaignResultsCommentsSuspense<TData = Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError = ErrorType<unknown>>(
 id: string,
    params: GetNpsCampaignResultsCommentsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getNpsCampaignResultsComments>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNpsCampaignResultsCommentsSuspenseQueryOptions(id,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const openNpsCampaign = (
    id: string,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/nps/campaigns/${id}/open`, method: 'PATCH'
    },
      options);
    }
  


export const getOpenNpsCampaignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openNpsCampaign>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof openNpsCampaign>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['openNpsCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof openNpsCampaign>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  openNpsCampaign(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OpenNpsCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof openNpsCampaign>>>
    
    export type OpenNpsCampaignMutationError = ErrorType<unknown>

    export const useOpenNpsCampaign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof openNpsCampaign>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof openNpsCampaign>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getOpenNpsCampaignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const closeNpsCampaign = (
    id: string,
 options?: SecondParameter<typeof instance>,) => {
      
      
      return instance<void>(
      {url: `/api/v1/nps/campaigns/${id}/close`, method: 'PATCH'
    },
      options);
    }
  


export const getCloseNpsCampaignMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeNpsCampaign>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof closeNpsCampaign>>, TError,{id: string}, TContext> => {
    
const mutationKey = ['closeNpsCampaign'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof closeNpsCampaign>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  closeNpsCampaign(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CloseNpsCampaignMutationResult = NonNullable<Awaited<ReturnType<typeof closeNpsCampaign>>>
    
    export type CloseNpsCampaignMutationError = ErrorType<unknown>

    export const useCloseNpsCampaign = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof closeNpsCampaign>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof closeNpsCampaign>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getCloseNpsCampaignMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getCurrentNpsCampaign = (
    
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<CurrentNpsCampaignQueryResponse>(
      {url: `/api/v1/nps/current`, method: 'GET', signal
    },
      options);
    }
  

export const getGetCurrentNpsCampaignQueryKey = () => {
    return [`/api/v1/nps/current`] as const;
    }

    
export const getGetCurrentNpsCampaignInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCurrentNpsCampaign>>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentNpsCampaignQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentNpsCampaign>>> = ({ signal }) => getCurrentNpsCampaign(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCurrentNpsCampaignInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentNpsCampaign>>>
export type GetCurrentNpsCampaignInfiniteQueryError = ErrorType<unknown>


export function useGetCurrentNpsCampaignInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCurrentNpsCampaign>>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentNpsCampaign>>,
          TError,
          Awaited<ReturnType<typeof getCurrentNpsCampaign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCurrentNpsCampaignInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCurrentNpsCampaign>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentNpsCampaign>>,
          TError,
          Awaited<ReturnType<typeof getCurrentNpsCampaign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCurrentNpsCampaignInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCurrentNpsCampaign>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCurrentNpsCampaignInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCurrentNpsCampaign>>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCurrentNpsCampaignInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCurrentNpsCampaignQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentNpsCampaignQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentNpsCampaign>>> = ({ signal }) => getCurrentNpsCampaign(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCurrentNpsCampaignQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentNpsCampaign>>>
export type GetCurrentNpsCampaignQueryError = ErrorType<unknown>


export function useGetCurrentNpsCampaign<TData = Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentNpsCampaign>>,
          TError,
          Awaited<ReturnType<typeof getCurrentNpsCampaign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCurrentNpsCampaign<TData = Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentNpsCampaign>>,
          TError,
          Awaited<ReturnType<typeof getCurrentNpsCampaign>>
        > , 'initialData'
      >, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCurrentNpsCampaign<TData = Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCurrentNpsCampaign<TData = Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCurrentNpsCampaignQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetCurrentNpsCampaignSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCurrentNpsCampaignQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCurrentNpsCampaign>>> = ({ signal }) => getCurrentNpsCampaign(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCurrentNpsCampaignSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCurrentNpsCampaign>>>
export type GetCurrentNpsCampaignSuspenseQueryError = ErrorType<unknown>


export function useGetCurrentNpsCampaignSuspense<TData = Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCurrentNpsCampaignSuspense<TData = Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCurrentNpsCampaignSuspense<TData = Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetCurrentNpsCampaignSuspense<TData = Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCurrentNpsCampaign>>, TError, TData>>, request?: SecondParameter<typeof instance>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCurrentNpsCampaignSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const submitNpsResponse = (
    campaignId: string,
    submitNpsResponseBody: BodyType<SubmitNpsResponseBody>,
 options?: SecondParameter<typeof instance>,signal?: AbortSignal
) => {
      
      
      return instance<void>(
      {url: `/api/v1/nps/${campaignId}/responses`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: submitNpsResponseBody, signal
    },
      options);
    }
  


export const getSubmitNpsResponseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitNpsResponse>>, TError,{campaignId: string;data: BodyType<SubmitNpsResponseBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationOptions<Awaited<ReturnType<typeof submitNpsResponse>>, TError,{campaignId: string;data: BodyType<SubmitNpsResponseBody>}, TContext> => {
    
const mutationKey = ['submitNpsResponse'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof submitNpsResponse>>, {campaignId: string;data: BodyType<SubmitNpsResponseBody>}> = (props) => {
          const {campaignId,data} = props ?? {};

          return  submitNpsResponse(campaignId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SubmitNpsResponseMutationResult = NonNullable<Awaited<ReturnType<typeof submitNpsResponse>>>
    export type SubmitNpsResponseMutationBody = BodyType<SubmitNpsResponseBody>
    export type SubmitNpsResponseMutationError = ErrorType<unknown>

    export const useSubmitNpsResponse = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof submitNpsResponse>>, TError,{campaignId: string;data: BodyType<SubmitNpsResponseBody>}, TContext>, request?: SecondParameter<typeof instance>}
): UseMutationResult<
        Awaited<ReturnType<typeof submitNpsResponse>>,
        TError,
        {campaignId: string;data: BodyType<SubmitNpsResponseBody>},
        TContext
      > => {

      const mutationOptions = getSubmitNpsResponseMutationOptions(options);

      return useMutation(mutationOptions);
    }
    